import React from 'react';
import { useParams } from 'react-router-dom';
import CustomerDetailsRepaymentRecord from './CustomerDetailsRepaymentRecord';

const CustomerDetailsRepayment = () => {
  const { customerId } = useParams<{ customerId: string}>();
  return (
    <div>
      <CustomerDetailsRepaymentRecord defaultUrl="repayment" toggleStorageId="customer-details-repayment-table-col" merchantId={customerId} />
    </div>
  );
};
export default CustomerDetailsRepayment;
